import { Head } from 'features/head'
import { Suspense, lazy } from 'react'

const UserAccounts = lazy(() => import('features/user-accounts'))

export const UserAccountsPage: React.FC = () => {
  return (
    <>
      <Head title='User Accounts' />
      <Suspense fallback={<p>Loading...</p>}>
        <UserAccounts />
      </Suspense>
    </>
  )
}
